const monitoredDevicesTutorial = {
  module: 'monitored_devices',
  moduleName: 'Monitored Devices',
  steps: [
    { target: '.md-stats-grid', position: 'bottom', title: 'Device Status', description: 'Quick view of total, online, offline, and degraded devices.' },
    { target: '.page-header-actions .btn-accent', position: 'bottom', title: 'Add Device', description: 'Manually add a device to monitoring.' },
    { target: '.page-header-actions .btn-secondary', position: 'bottom', title: 'Sync', description: 'Pull device lists from your VMS and access control integrations.' },
  ],
};
export default monitoredDevicesTutorial;
